import { useEffect } from 'react';
import { useWebsockets } from './use-websockets';
/**
 * Subscribe to websocket events.
 *
 * This function takes the same arguments as `ClientSideSocket.on`.
 * @param ev - Name of the event
 * @param listener - Callback function
 */
export function useWebsocketListener(ev, listener) {
  const client = useWebsockets();

  // Using listener as a dependency without useCallback for this effect
  // should be fine; Adding and removing listeners should be very fast.
  useEffect(() => {
    client?.on(ev, listener);
    return () => {
      client?.off(ev, listener);
    };
  }, [client, ev, listener]);
}